
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#F4FBFE","d":"M11.904 40.915v3.155l3.617.818v2.799h-3.617v3.616h19.892v-3.616h3.617V44.07h-3.617v-3.617zM21.85 16.328l-9.946 15.084 34.359.276-9.645-16.551H21.85zM39 32h7v11h-7z"}}),_c('g',{attrs:{"stroke":"#5FB8EE","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.808"}},[_c('path',{attrs:{"d":"M53.496 31.412H11.904l9.946-16.275 9.946 16.275M29.083 15.137l9.946 16.275M36.317 15.137l9.946 16.275M31.796 36.837v-5.425M11.904 31.412v5.425M21.85 15.137h22.604M25.165 20.562h22.906M28.481 25.987h23.207M30.892 51.303h21.7c.499 0 .904-.404.904-.904v-7.233c0-.5-.405-.904-.904-.904H39.029M39.029 31.412v10.85M46.263 31.412v10.85"}}),_c('path',{attrs:{"d":"M11.904 47.687h19.892v3.616H11.904zM15.521 44.07h19.892v3.617H15.521zM11.904 40.453h19.892v3.617H11.904z"}})]),_c('path',{attrs:{"stroke":"#5FB8EE","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.808","d":"M53.496 31.412H11.904l9.946-16.275 9.946 16.275M29.083 15.137l9.946 16.275M36.317 15.137l9.946 16.275M31.796 36.837v-5.425M11.904 31.412v5.425M21.85 15.137h22.604M25.165 20.562h22.906M28.481 25.987h23.207M30.892 51.303h21.7c.499 0 .904-.404.904-.904v-7.233c0-.5-.405-.904-.904-.904H39.029M39.029 31.412v10.85M46.263 31.412v10.85"}}),_c('path',{attrs:{"stroke":"#5FB8EE","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.808","d":"M11.904 47.687h19.892v3.616H11.904zM15.521 44.07h19.892v3.617H15.521zM11.904 40.453h19.892v3.617H11.904z"}})])])
          )
        }
      }
    